// list of firebase references
export default class FirestoreReferences {
  public static readonly ORDERS = "orders";
  public static readonly RELAYS = "relays";
  public static readonly PRODUCTS = "products";
  public static readonly BAGS = "bags";
}
